import { User } from "lucide-react";
import React from 'react';
import { useTranslation } from 'react-i18next'; // ADD THIS IMPORT
import { Service } from '../../../shared/hooks/useServiceSelection';
import { SectionTitle } from "./SectionTitle";

interface Provider {
  firstName: string;
  lastName: string;
  image?: {
    url: string;
  };
}

interface ProvidersSectionProps {
  serviceProviderMap: Record<string, Provider>;
  selectedServices: Service[];
  colors?: any;
}

export const ProvidersSection: React.FC<ProvidersSectionProps> = ({
  serviceProviderMap,
  selectedServices,
  colors = {}
}) => {
  const { t } = useTranslation(); // ADD THIS LINE

  const defaultColors = {
    cardBackground: "#000000F2",
    cardBorder: "#DDB88919",
    cardShadow: "rgba(221,184,137,0.07)",
    cardShadowSelected: "rgba(221,184,137,0.1)",
    titleText: "#DDB889",
    subtitleText: "#DDB889CC",
    infoText: "#DDB88999",
    iconColor: "#DDB889"
  };

  // Merge default colors with provided colors
  const mergedColors = { ...defaultColors, ...colors };

  // Create style objects from the colors
  const cardStyle = {
    backgroundColor: mergedColors.cardBackground,
    borderColor: mergedColors.cardBorder,
    boxShadow: `0 0 15px ${mergedColors.cardShadow}`
  };

  const nameStyle = {
    color: mergedColors.subtitleText
  };

  const serviceNameStyle = {
    color: mergedColors.infoText
  };

  const imageBorderStyle = {
    borderColor: mergedColors.cardBorder
  };

  return (
    <div
      className="lp-backdrop-blur-sm lp-border lp-rounded-2xl lp-p-6 lp-transition-all lp-duration-700 hover:lp-shadow-[0_0_20px_rgba(221,184,137,0.1)]"
      style={cardStyle}
    >
      <SectionTitle
        icon={User}
        title={t('providersSection.selectedProviders')} /* CHANGED: "Selected Providers" */
        colors={mergedColors}
      />
      <div className="lp-space-y-4">
        {Object.entries(serviceProviderMap).map(([serviceId, provider]) => {
          const service = selectedServices.find(s => s.id === serviceId || s.id === serviceId);
          return (
            <div
              key={serviceId}
              className="lp-flex lp-items-center lp-justify-between lp-gap-4 group lp-transition-all lp-duration-200 hover:lp-translate-x-1"
            >
              <div className="lp-flex lp-items-center lp-gap-4">
                {provider.image && (
                  <div className="lp-relative">
                    <img
                      src={provider.image.url}
                      alt={`${provider.firstName} ${provider.lastName}`}
                      className="lp-w-12 lp-h-12 lp-rounded-full lp-object-cover lp-border lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
                      style={imageBorderStyle}
                    />
                    <div
                      className="lp-absolute lp-inset-0 lp-rounded-full lp-transition-shadow lp-duration-200"
                    />
                  </div>
                )}
                <div>
                  <p
                    className="lp-font-medium lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]"
                    style={nameStyle}
                  >
                    {provider.firstName} {provider.lastName}
                  </p>
                  <p
                    className="lp-text-sm lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]/80"
                    style={serviceNameStyle}
                  >
                    {service?.name}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
